import { RootState } from "../store";

export const mallSelect = (state: RootState) => state.mallReducer;
